import React, { DragEvent as ReactDragEvent, useEffect, useState } from 'react';
import { shallowEqual, useDispatch } from 'react-redux';
import { setDrag } from '../../reducers/drag/dragReducerActions';
import Client from '../../utils/network';
import { MapImageWithImageDetails } from '../../reducers/map/mapReducer';
import { useSelector } from 'react-redux';
import { Rootstate } from '../../store';
import { ObjectId } from 'bson';
import { CreateMapImageModal } from './CreateMapImageModal';

function MapImageCreator() {
    const dispatch = useDispatch();
    const [insertableImages, setInsertableImages] = useState<MapImageWithImageDetails[]>();


    const { layer } = useSelector((state: Rootstate) => ({
        layer: state.map.mainLayer,
    }), shallowEqual);

    const getInsertableTokens = () => {
        Client.request('/api/map-image?getimageDetails=true').then(async (res) => {
            const body = await res.json() as MapImageWithImageDetails[];
            setInsertableImages(body);
            return;
        }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
        });
    };

    useEffect(() => {
        getInsertableTokens();
    }, []);

    const startDraggingMapImage = (e: ReactDragEvent<HTMLImageElement>, image: MapImageWithImageDetails) => {
        e.preventDefault();

        const onDragEnd = () => {
            dispatch(setDrag(false));
            window.removeEventListener('mouseup', onDragEnd);
        };

        window.addEventListener('mouseup', onDragEnd);

        dispatch(setDrag(
            true,
            {
                type: 'move-map-image',
                details: {
                    image: {
                        ...image,
                        image: image.image._id,
                        width: image.image.width,
                        height: image.image.height,
                        _id: new ObjectId(),
                        xPos: e.clientX,
                        yPos: e.clientY,
                        dm: layer === 'dm',
                    },
                    startX: e.clientX,
                    startY: e.clientY,
                    rotate: image.rotation ?? 0,
                },
            },
        ));
    };


    const loadMapImages = () => {
        Client.request('/api/map-image?getimageDetails=true').then(async (res) => {
            const body = await res.json() as MapImageWithImageDetails[];
            setInsertableImages(body);
            return;
        }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
        });
    };

    return (
        <div className="flex align-center gap-2">
            <div className=" min-h-24 min-w-[600px] bg-deep-blue rounded-2xl">
                <div className='grid grid-flow-col grid-rows-2 p-3 gap-6 w-fit'>
                    {(insertableImages ?? []).map((mapImage) => {
                        return (
                            <img
                                key={mapImage._id.toString()}
                                className='max-w-12 max-h-12'
                                onDragStart={(e) => startDraggingMapImage(e, mapImage)}
                                src={`${Client.getBaseUrl()}/api/image/${mapImage.image._id}/thumbnail`}
                            />
                        );
                    })}
                </div>
            </div>
            <CreateMapImageModal loadMapImages={loadMapImages} />
        </div>
    );
}
export default MapImageCreator;
